import { Dto, DtoWithId } from "@mango/core";
import { Artikel } from "./artikel";
import { Factuur } from './factuur';
import { Pakbonregel } from "./pakbonregel";

@Dto({fullName: "CIJBorculo.Logic.Factuurregel"})
export class Factuurregel extends DtoWithId {
	factuur: Factuur;
	pakbonregel: Pakbonregel;
	prijs: number;
	korting: number;
	aantal: number;
	artikel: Artikel;
	omschrijving: string;
	regelprijs: number;
}